import { apiCall } from 'api';
import {
  PLAYER_GETMEDIA_PATH,
  PLAYER_GETMEDIA_PATH_V3,
} from 'api/services/player/paths';
import { TOOLBOX_MAP } from 'containers/Player/constants';
import { getUserToken } from 'utils/user/getUserToken';

export const getPlayerGetMediaPath = (
  claroLiteEnable,
  isLive,
  user_token,
  payway_token,
  contentData,
) => {
  const useTokenAds = getUserToken();
  const playerGetMediaObject = {
    url: PLAYER_GETMEDIA_PATH,
    apiVersion: null,
    bodyParams: null,
    userToken: null,
    paywayToken: null,
  };
  const providerCode =
    contentData?.data?.group?.common?.extendedcommon?.media?.proveedor?.codigo;
  const isToolBoxFlow =
    !isLive && (useTokenAds || user_token) && TOOLBOX_MAP[providerCode];
  const isPlayerGetMediaV1Flow =
    claroLiteEnable || ((useTokenAds || user_token) && isLive);
  if (isToolBoxFlow) {
    playerGetMediaObject.url = PLAYER_GETMEDIA_PATH_V3;
    playerGetMediaObject.userToken = user_token;
    playerGetMediaObject.paywayToken = payway_token;
    return playerGetMediaObject;
  }
  if (isPlayerGetMediaV1Flow) {
    playerGetMediaObject.userToken =
      claroLiteEnable && !user_token ? useTokenAds : user_token;
    playerGetMediaObject.paywayToken = payway_token;
    return playerGetMediaObject;
  }

  playerGetMediaObject.url = '/services/player/getmedia';
  playerGetMediaObject.apiVersion = 'v5.94';
  const formData = new FormData();
  if (user_token) formData.append('user_token', user_token);
  if (payway_token) formData.append('payway_token', payway_token);
  playerGetMediaObject.bodyParams = formData;

  return playerGetMediaObject;
};
